if(!customElements.get('links-with-media')){
    class LinksWithMedia extends HTMLElement {
        constructor(){
            super();
        }

        connectedCallback(){
            this.section = this.closest('.section-links-with-media');
            this.popupLinksWithMedia = this.section?.querySelector('.links-with-media-product-popup');

            this.videos = this.querySelectorAll('video');
            this.links = this.querySelectorAll('.link-wrapper');
            this.mediaDesktop = this.querySelectorAll(".media-wrapper-desktop .media-wrapper");
            this.currentIndex = 1;

            this.links.forEach(item => {
                item.addEventListener('mouseenter', this.updateMedia.bind(this));
                item.addEventListener('focus', this.updateMedia.bind(this));
                item.addEventListener('keydown', (e) => {
                    if(e.key === 'Enter' || e.key === ' '){
                        const childLink = item.querySelector('a');
                        if(childLink){
                            e.preventDefault();
                            childLink.click();
                        }
                    }
                    if(e.key === 'Tab' && !e.shiftKey){
                        const index = item.dataset.index;
                        const mediaPanel = this.querySelector(`.media-wrapper-desktop .media-wrapper[data-index="${index}"]`);
                        if(mediaPanel){
                            const firstFocusable = mediaPanel.querySelector('.hotspot-icon[tabindex="0"]');
                            if(firstFocusable){
                                e.preventDefault();
                                firstFocusable.focus();
                            }
                        }
                    }
                });
            });

            this.videos.forEach(video => {
                if(typeof video === 'undefined') return;
                video.addEventListener("loadeddata", e => {
                    video.classList.add('loaded');
                });

                if(video.readyState >= 2){
                    video.classList.add('loaded');
                }
            });

            this.initializeSwiper();

            // hotspot
            this.hotspots = this.querySelectorAll('.links-with-media__hotspot');
            this.hotspots.forEach(item => {
                const hotspotIcon = item.querySelector('.hotspot-icon');
                hotspotIcon?.addEventListener("click", this.openProductCta.bind(this));
                hotspotIcon?.addEventListener("keydown", e => {
                    if(e.key === 'Enter' || e.key === ' '){
                        e.preventDefault();
                        this.openProductCta(e);
                    }
                    if(e.key === 'Tab' && !e.shiftKey){
                        const mediaPanel = item.closest('.media-wrapper[data-index]');
                        if(mediaPanel){
                            const hotspotIcons = mediaPanel.querySelectorAll('.hotspot-icon[tabindex="0"]');
                            const isLast = hotspotIcons.length === 0 || hotspotIcons[hotspotIcons.length - 1] === hotspotIcon;
                            if(isLast){
                                const currentIndex = parseInt(mediaPanel.dataset.index);
                                const nextLink = this.querySelector(`.link-wrapper[data-index="${currentIndex + 1}"]`);
                                if(nextLink){
                                    e.preventDefault();
                                    nextLink.focus();
                                }
                            }
                        }
                    }
                });

                // close button
                const hotspotCta = item.querySelector(".hotspot-cta");
                if(hotspotCta){
                    const buttonClose = hotspotCta.querySelector('.button-close');
                    buttonClose?.addEventListener("click", this.closeProductPopupByButton.bind(this));
                    buttonClose?.addEventListener("keydown", e => {
                        if(e.key === 'Enter' || e.key === ' '){
                            e.preventDefault();
                            this.closeProductPopupByButton(e);
                        }
                    });

                    // close on Escape
                    hotspotCta.addEventListener("keydown", e => {
                        if(e.key === 'Escape'){
                            this.closeProductPopup(hotspotCta);
                            hotspotIcon?.focus();
                        }
                    });
                }

                // close popup when clicking outside
                document.addEventListener("click", e => {
                    if(!hotspotCta.contains(e.target) && !hotspotIcon.contains(e.target)){
                        this.closeProductPopup(hotspotCta);
                    }
                });

                document.addEventListener("focus", (e) => {
                    if (!hotspotCta.contains(e.target) && !hotspotIcon.contains(e.target)) {
                        this.closeProductPopup(hotspotCta);
                    }
                }, true);
            });
        }

        async initializeSwiper(){
            this.swiperContainer = this.querySelector('.swiper-container');
            if(!this.swiperContainer) return;

            this.slides = this.querySelectorAll('.swiper-slide');
            if(this.slides.length <= 1) return;

            if(typeof Swiper === 'undefined'){
                await new Promise(resolve => {
                    const check = () => {
                        if(typeof Swiper !== 'undefined') resolve();
                        else requestAnimationFrame(check);
                    };
                    check();
                });
            }

            var swiperSettings = {
                init: false,
                initialSlide: 0,
                loop: false,
                centeredSlides: false,
                speed: 500,
                watchOverflow: true,
                breakpoints: {
                    0: { slidesPerView: 1 },
                    768: { slidesPerView: 1 }
                },
                observer: true,
                observeSlideChildren: true,
                autoHeight: false,
                spaceBetween: 10,
                on: {
                    slideChange: () => {
                        const currentIndex = this.swiper.activeIndex;
                        this.updateMobileList(`${currentIndex + 1}`);
                    }
                }
            }

            this.swiper = new Swiper(this.swiperContainer, swiperSettings);
            this.swiper.init();

            this.swiper.on("resize", () => {  this.swiper.update(); })
        }

        updateMedia(e){
            const currentElem = e.currentTarget;
            if(!currentElem) return;

            this.closeAllProductPopups(); // close all product CTAs

            this.links.forEach(link => {
                link.setAttribute('data-active-desktop', link === currentElem? 'true' : 'false');
            });
            const currentIndex = currentElem.dataset.index;
            this.currentIndex = parseInt(currentIndex);

            this.mediaDesktop.forEach(item => {
                if(item.dataset.index === currentIndex){
                    item.setAttribute('aria-hidden', 'false');
                    item.removeAttribute('inert');
                    this.stopVideo();
                    this.playVideo();
                }else{
                    item.setAttribute('aria-hidden', 'true');
                    item.setAttribute('inert', '');
                }
            });
        }

        updateMobileList(currentIndex){
            this.links.forEach(item => {
                if(item.dataset.index === currentIndex){
                    item.setAttribute('data-active', 'true');
                }else{
                    item.setAttribute('data-active', 'false');
                }
            });
        }

        playVideo(){
            const currentMedia = this.ifMobile()? this.querySelector(`.swiper-slide[data-index="${this.currentIndex}"]`) : this.querySelector(`.media-wrapper[data-index="${this.currentIndex}"]`);
            if(!currentMedia) return;

            const video = currentMedia.querySelector('video');
            if(!video) return;

            video.play();
        }

        stopVideo(){
            this.videos.forEach(video => {
                video.pause();
                video.currentTime = 0;
            });
        }

        ifMobile(){
            return window.innerWidth <= 992;
        }

        openProductCta(e){
            if(!e.currentTarget) return;

            const hotspotIcon = e.currentTarget;
            const parent = hotspotIcon.closest('.links-with-media__hotspot');
            const productPopup = parent?.querySelector(".hotspot-cta");

            const width = window.innerWidth;

            if(productPopup){
                if(width < 991){ // mobile
                    this.openPopup(productPopup);
                    return;
                }

                //tab index
                productPopup.querySelectorAll('[tabindex]').forEach(item => {
                    item.setAttribute('tabindex', '0');
                });

                if(productPopup.getAttribute('data-hidden') === 'false'){
                    parent.style.zIndex = '20';
                    productPopup.setAttribute('data-hidden', 'true');
                    productPopup.setAttribute('inert', '');
                    hotspotIcon.setAttribute('aria-expanded', 'false');
                }else{
                    productPopup.setAttribute('data-hidden', 'false');
                    productPopup.removeAttribute('inert');
                    parent.style.zIndex = '21';
                    hotspotIcon.setAttribute('aria-expanded', 'true');
                    const closeBtn = productPopup.querySelector('.button-close');
                    if(closeBtn) closeBtn.focus();
                }
            }
        }

        openPopup(popup){
            if(!this.popupLinksWithMedia) return;

            this.popupLinksWithMedia.querySelector('.popup__content').innerHTML = popup.innerHTML;
            this.popupLinksWithMedia.setAttribute('data-hidden', 'false');
            this.popupLinksWithMedia.removeAttribute('inert');
            this.popupLinksWithMedia.querySelectorAll('[tabindex]').forEach(item => {
                item.setAttribute('tabindex', '1');
            });

            const buttonClose = this.popupLinksWithMedia.querySelector('.button-close');
            buttonClose.addEventListener("click", this.closePopup.bind(this));
            buttonClose.addEventListener("keydown", e => {
                if(e.key === 'Enter' || e.key === ' '){
                    e.preventDefault();
                    this.closePopup();
                }
            });

            this.popupLinksWithMedia.addEventListener("click", (e) => {
                if(this.popupLinksWithMedia === e.target){
                    this.closePopup();
                }
            });

            this.popupLinksWithMedia.addEventListener("keyup", (e) => {
                if(e.code && e.code.toUpperCase() === 'ESCAPE') this.closePopup();
            });

            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';

            this.previouslyFocusedElement = document.activeElement;

            FocusTrap.activate(this.popupLinksWithMedia);
        }

        closePopup(){
            if(!this.popupLinksWithMedia) return;

            FocusTrap.deactivate(this.popupLinksWithMedia);

            this.popupLinksWithMedia.setAttribute('data-hidden', 'true');
            this.popupLinksWithMedia.setAttribute('inert', '');

            const buttonClose = this.popupLinksWithMedia.querySelector('.button-close');
            buttonClose.removeEventListener("click", this.closePopup.bind(this));

            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';

            if(this.previouslyFocusedElement){
                this.previouslyFocusedElement.focus();
            }

            setTimeout(() => {
                this.popupLinksWithMedia.querySelector('.popup__content').innerHTML = '';
            }, 300);
        }

        closeProductPopupByButton(e){
            if(!e.currentTarget) return;
            const parent = e.currentTarget.closest(".links-with-media__hotspot");
            const productPopup = parent?.querySelector(".hotspot-cta");

            this.closeProductPopup(productPopup);
        }

        closeAllProductPopups(){
            this.hotspots.forEach(item => {
                const productPopup = item.querySelector(".hotspot-cta");
                this.closeProductPopup(productPopup);
            });
        }

        closeProductPopup(popup){
            if(!popup) return;

            popup.querySelectorAll('[tabindex]').forEach(item => {
                item.setAttribute('tabindex', '-1');
            });
            popup.setAttribute('data-hidden', 'true');
            popup.setAttribute('inert', '');

            const parent = popup.closest('.links-with-media__hotspot');
            const hotspotIcon = parent?.querySelector('.hotspot-icon');
            if(hotspotIcon) hotspotIcon.setAttribute('aria-expanded', 'false');
        }
    }

    customElements.define('links-with-media', LinksWithMedia);
}